import { StrictMode, useState, useEffect } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { store } from '../Redux'
import { useAppDispatch } from '../Hooks/redux'
import { startupRequest } from '../Redux/AuthRedux'
import AppRouter from './AppRouter'
import Loader from '../Components/Loader'

/**
 * Root application component.
 *
 * Mirrors the appointo_client pattern:
 *   1. App wraps everything in Provider + BrowserRouter.
 *   2. AppShell dispatches startupRequest on mount to restore
 *      the session from localStorage (same as appointo_client
 *      StartupSagas + Main.js).
 *   3. Until startup completes, a loading spinner is shown.
 */

function AppShell() {
  const [ready, setReady] = useState(false)
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(
      startupRequest({
        callback: () => setReady(true),
      }),
    )
  }, [dispatch])

  if (!ready) {
    return <Loader size="lg" fullScreen label="Loading..." />
  }

  return <AppRouter />
}

export default function App() {
  return (
    <StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </Provider>
    </StrictMode>
  )
}
